import React, {useState} from 'react';
import './Navbar.scss';
import BdwLogoMini from '../../assets/images/bdwLogoMini.png';

const Navbar: React.FC = () => {
    //const [isArrowActive, setIsArrowActive] = useState(false);
    //const [isProjekatActive, setIsProjekatActive] = useState(false);
    const [isRadioniceActive, setIsRadioniceActive] = useState(false);
    const [isVestiActive, setIsVestiActive] = useState(false);
    const [lastClicked, setLastClicked] = useState(-1);
    
    // const handleProjekatState = () => {
    //     falsefyDesktop(0);
    //     setIsProjekatActive(!isProjekatActive);
    //     if(lastClicked !== 0) setIsArrowActive(true);
    //     else setIsArrowActive(!isArrowActive);
    //     setLastClicked(0);
    // }

    const handleScrollAction = (id: string) => {
        const element = document.getElementById("scrollElement" + id);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    }

    // const handleRadioniceState = () => {
    //     falsefyDesktop(1);
    //     setIsRadioniceActive(!isRadioniceActive);
    //     if(lastClicked !== 1) setIsArrowActive(true);
    //     else setIsArrowActive(!isArrowActive);
    //     setLastClicked(1);
    // }

    // const handleVestiState = () => {
    //     falsefyDesktop(2);
    //     setIsVestiActive(!isVestiActive);
    //     if(lastClicked !== 2) setIsArrowActive(true);
    //     else setIsArrowActive(!isArrowActive);
    //     setLastClicked(2);
    // }

    const falsefyDesktop = (exclusion: number) => {
        //if (exclusion !== 0) setIsProjekatActive(false);
        if (exclusion !== 1) setIsRadioniceActive(false);
        if (exclusion !== 2) setIsVestiActive(false);
    }

    const handleDropdownClick = (id: string) => {
        falsefyDesktop(-1);
        //setIsArrowActive(false);
        handleScrollAction(id);
    }
    

    //Moble Burger
    
    const [isMobileBurgerActive, setIsMobileBurgerActive] = useState(false);
    const [isMobileProjekatActive, setIsMobileProjekatActive] = useState(false);
    const [isMobileRadioniceActive, setIsMobileRadioniceActive] = useState(false);
    const [isMobileVestiActive, setIsMobileVestiActive] = useState(false);
    const [isMobilePartneriActive, setIsMobilePartneriActive] = useState(false);
    const [isMobileOrganizatoriActive, setIsMobileOrganizatoriActive] = useState(false);
    const [isMobileKontaktActive, setIsMobileKontaktActive] = useState(false);

    const handleBurgerToggle = () => {
        falsefyMobile(-1);
        setIsMobileBurgerActive(!isMobileBurgerActive);
    }

    const falsefyMobile = (exclusion: number) => {
        //04:38 ujutru je ne mogu bolje resenje da smislim...
        if (exclusion !== 0) setIsMobileProjekatActive(false);
        if (exclusion !== 1) setIsMobileRadioniceActive(false);
        if (exclusion !== 2) setIsMobileVestiActive(false);
        if (exclusion !== 3) setIsMobilePartneriActive(false);
        if (exclusion !== 4) setIsMobileOrganizatoriActive(false);
        if (exclusion !== 5) setIsMobileKontaktActive(false);
    };

    const handleMobileProjekat = () => {
        falsefyMobile(0);
        setIsMobileProjekatActive(!isMobileProjekatActive);
    }

    const handleMobileRadionice = () => {
        falsefyMobile(1);
        setIsMobileRadioniceActive(!isMobileRadioniceActive);
    }

    const handleMobileVesti = () => {
        falsefyMobile(2);
        setIsMobileVestiActive(!isMobileVestiActive);
    }

    const handleMobilePartneri = () => {
        falsefyMobile(3);
        setIsMobilePartneriActive(!isMobilePartneriActive);
    }

    const handleMobileOrganizatori = () => {
        falsefyMobile(4);
        setIsMobileOrganizatoriActive(!isMobileOrganizatoriActive);
    }

    const handleMobileKontakt = () => {
        falsefyMobile(5);
        setIsMobileKontaktActive(!isMobileKontaktActive);
    }

    const handleLevel2DropdownClick = (id: string) => {
        setIsMobileBurgerActive(false);
        if (id === '1') handleMobileProjekat();
        if (id === '10') handleMobilePartneri();
        if (id === '11') handleMobileOrganizatori();
        if (id === '12') handleMobileKontakt();

        handleScrollAction(id);
    };

    const keepDropdownOpen = (id: number) => {
        if (id === 0) setIsRadioniceActive(true);
        if (id === 1) setIsVestiActive(true);
        //setIsArrowActive(true);
    }

    const closeDropdown = (id: number) => {
        if (id === 0) setIsRadioniceActive(false);
        if (id === 1) setIsVestiActive(false);
        //setIsArrowActive(false);
    }

    return (
        <nav>
            <div className='left-section'>
                <img src={BdwLogoMini} alt='Logo' className='nav-logo' onClick={() => handleScrollAction('0')}/>
                <button className='prijava-btn' onClick={() => window.open("", "_blank")}>Vidimo se!</button>
            </div>
            

            <ul className='nav-list'>
                {/*<div id='arrow-icon1'>
                   <span className={isArrowActive ? 'active' : ''}></span>
                    <span className={isArrowActive ? 'active' : ''}></span>
                </div>*/}
                <div className='nav-list-el'>
                    <li className='nav-list-li' onClick={() => handleScrollAction('1')}>Design Insight</li>
                    {/* <div className={'dropdown' + (isProjekatActive ? ' active' : '')}>
                        <ul className='dropdown-list'>
                            <li className='dropdown-li' onClick={() => handleDropdownClick('0')}>Design Insight</li>
                        </ul>
                    </div> */}
                </div>
                <div className='nav-list-el'>
                    <li className='nav-list-li' onMouseEnter={() => keepDropdownOpen(0)} onMouseLeave={() => closeDropdown(0)}>Radionice</li>
                    <div className={'dropdown' + (isRadioniceActive ? ' active' : '')}>
                        <ul className='dropdown-list'>
                            <li className='dropdown-li' onClick={() => handleScrollAction('graphic-raster')} onMouseEnter={() => keepDropdownOpen(0)} onMouseLeave={() => closeDropdown(0)}>Graphic Design Raster</li>
                            <li className='dropdown-li' onClick={() => handleScrollAction('21')} onMouseEnter={() => keepDropdownOpen(0)} onMouseLeave={() => closeDropdown(0)}>Graphic Design Vector</li>
                            <li className='dropdown-li' onClick={() => handleScrollAction('31')} onMouseEnter={() => keepDropdownOpen(0)} onMouseLeave={() => closeDropdown(0)}>Flow&Motion Design</li>
                            <li className='dropdown-li' onClick={() => handleScrollAction('41')} onMouseEnter={() => keepDropdownOpen(0)} onMouseLeave={() => closeDropdown(0)}>WebFlow</li>
                            <li className='dropdown-li' onClick={() => handleScrollAction('6')} onMouseEnter={() => keepDropdownOpen(0)} onMouseLeave={() => closeDropdown(0)}>Digital Photography</li>
                            <li className='dropdown-li' onClick={() => handleScrollAction('7')} onMouseEnter={() => keepDropdownOpen(0)} onMouseLeave={() => closeDropdown(0)}>Video Editing</li>
                        </ul>
                    </div>
                </div>
                <div className='nav-list-el'>
                    <li className='nav-list-li' onMouseEnter={() => keepDropdownOpen(1)} onMouseLeave={() => closeDropdown(1)}>Vesti</li>
                    <div className={'dropdown' + (isVestiActive ? ' active' : '')}>
                        <ul className='dropdown-list'>
                            <li className='dropdown-li' onClick={() => handleScrollAction('9')} onMouseEnter={() => keepDropdownOpen(1)} onMouseLeave={() => closeDropdown(1)}>Novosti</li>
                            <li className='dropdown-li' onClick={() => handleScrollAction('9')} onMouseEnter={() => keepDropdownOpen(1)} onMouseLeave={() => closeDropdown(1)}>Zanimljivosti</li>
                        </ul>
                    </div>
                </div>
                <li className='nav-list-li' onClick={() => handleScrollAction('10')}>Partneri</li>
                <li className='nav-list-li' onClick={() => handleScrollAction('11')}>Organizatori</li>
                <li className='nav-list-li' onClick={() => handleScrollAction('12')}>Kontakt</li>
            </ul>

            <div className='burger-menu'>
                <div id="nav-icon2" onClick={handleBurgerToggle} className={isMobileBurgerActive ? 'open' : ''}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                {/* Zanimljiva stvar:
                    Ako ima level2 dropdown, active hadnle se obavlja na .level2-dropdown,
                    a ako nema obavlja se direktno na .burger-dropdown-li.
                */}
                <div className={'burger-dropdown' + (isMobileBurgerActive ? ' active' : '')}>
                    <ul className='burger-dropdown-list'>
                        {/* <div className={'level2-dropdown' + (isMobileProjekatActive ? ' active' : '')} onClick={handleMobileProjekat}> */}
                            {/* <div className={'left-arrow' + (isMobileProjekatActive ? ' active' : '')}>
                                <span></span>
                                <span></span>
                            </div> */}
                            <li className={'burger-dropdown-li' + (isMobileProjekatActive ? ' active' : '')} onClick={() => handleLevel2DropdownClick('1')}>Design Insight</li>
                            {/* <div className={'level2-dropdown-container' + (isMobileProjekatActive ? ' active' : '')}>
                                <ul className='level2-dropdown-list'>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('0')}>Design Insight</li>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('1')}>Program</li>
                                </ul>
                            </div> */}
                        {/* </div> */}
                        <div className={'level2-dropdown' + (isMobileRadioniceActive ? ' active' : '')} onClick={handleMobileRadionice}>
                            <div className={'left-arrow' + (isMobileRadioniceActive ? ' active' : '')}>
                                <span></span>
                                <span></span>
                            </div>
                            <li className='burger-dropdown-li'>Radionice</li>
                            <div className={'level2-dropdown-container' + (isMobileRadioniceActive ? ' active' : '')}>
                                <ul className='level2-dropdown-list'>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('2')}>Graphic Design Basic</li>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('3')}>Graphic Design Advanced</li>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('4')}>Web Design HTML/CSS</li>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('5')}>WebFlow</li>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('6')}>Digital Photography</li>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('7')}>Video Editing</li>
                                </ul>
                            </div>
                        </div>
                        <div className={'level2-dropdown' + (isMobileVestiActive ? ' active' : '')} onClick={handleMobileVesti}>
                            <div className={'left-arrow' + (isMobileVestiActive ? ' active' : '')}>
                                <span></span>
                                <span></span>
                            </div>
                            <li className='burger-dropdown-li'>Vesti</li>
                            <div className={'level2-dropdown-container' + (isMobileVestiActive ? ' active' : '')}>
                                <ul className='level2-dropdown-list'>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('9')}>Novosti</li>
                                    <li className='level2-dropdown-li' onClick={() => handleLevel2DropdownClick('9')}>Zanimljivosti</li>
                                </ul>
                            </div>
                        </div>
                        <li className={'burger-dropdown-li' + (isMobilePartneriActive ? ' active' : '')} onClick={() => handleLevel2DropdownClick('10')}>Partneri</li>
                        <li className={'burger-dropdown-li' + (isMobileOrganizatoriActive ? ' active' : '')} onClick={() => handleLevel2DropdownClick('11')}>Organizatori</li>
                        <li className={'burger-dropdown-li' + (isMobileKontaktActive ? ' active' : '')} onClick={() => handleLevel2DropdownClick('12')}>Kontakt</li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;